<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container" style="width:100% !important">
                <h1 class="page-title"> {{page_header}} </h1>
                <button type="submit" v-on:click.prevent="returnOnListing()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->
                <div class="forms-container">
                    <div class="row no-margin">
                        <!-- Name -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{name}}</span>
                            </div>
                        </div>

                        <!-- Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Email :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{email}}</span>
                            </div>
                        </div>

                        <!-- Primary Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Primary Email :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{primaryEmail}}</span>
                            </div>
                        </div>

                        <!-- Contact -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Contact :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{contact}}</span>
                            </div>
                        </div>

                        <!-- Secondary Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Secondary Email :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{secondaryEmail}}</span>
                            </div>
                        </div>

                        <!-- Secondary Contact -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Secondary Contact :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{secondaryContact}}</span>
                            </div>
                        </div>

                        <!-- Third Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Third Email :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{thirdEmail}}</span>
                            </div>
                        </div>

                        <!-- Third Contact -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Third Contact :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{thirdContact}}</span>
                            </div>
                        </div>
                        
                        <!-- Address Line 1 -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Address Line 1 :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{addressLine1}}</span>
                            </div>
                        </div>

                        <!-- Address Line 2 -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Address Line 2 :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{addressLine2}}</span>
                            </div>
                        </div>
                        
                        <!-- Location -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Location :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{locationId.name}}</span>
                            </div>
                        </div>
                        
                        <!-- Zip Code -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Zip Code :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{zipCode}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <!-- <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.saveButton" class="btn btn-primary" v-on:click.prevent="customerProfileUpdate()"> -->
                        <!-- <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary" v-on:click.prevent="returnOnListing"> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import { Form } from 'bootstrap-vue/es/components';
    import { FormRadio } from 'bootstrap-vue/es/components';
    import Footer from '@/components/partials/CustomerFooter';
    import EventBus from '.././event-bus';
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    var self;

    export default {
        name: 'CustomerProfile',
        mixins: [commonMixins],
        components: {
            'v-select': vSelect,
            'app-footer': Footer,
        },
        data() {
            return {
                page_header: "Profile",
                customerLoginId: 0,
                name : '',
                nameError : '',
                email : "",
                primaryEmail : "",
                secondaryEmail : "",
                thirdEmail : "",
                addressLine1: "",
                addressLine2: "",
                locationId: {
                    'name' : "",
                    'id' : "",
                },
                zipCode: "",
                contact : "",
                secondaryContact : "",
                thirdContact : "",

                buttonNames : {
                    saveButton : 'Update',
                    cancel: 'Cancel'
                },
                disableButtons : {
                    save : false,
                    cancel : false,
                },
            }
        },
        watch: {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.customerProtal();
            var customerObj = localStorage.getItem("customer_obj");
            //if user logged in than remove login button and registration button
            if (customerObj != null) {
                var custJson = JSON.parse(customerObj);
                self.customerLoginId = custJson['id'];
                self.getCustomerProfileData();
            }
        },
        methods: {
            returnOnListing: function() {
                self.$router.push({name:'CustomerDashboard'});
            },
            getCustomerProfileData: function() {
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                    params: {
                        cust_id: self.customerLoginId
                    }
                };
                HTTP.get('/get-customer-profile-data', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.name = response.data.customer.name;
                            self.email = response.data.customer.email;
                            self.primaryEmail = response.data.customer.primary_email;
                            self.secondaryEmail = response.data.customer.secondary_email;
                            self.thirdEmail = response.data.customer.third_email;
                            self.contact = response.data.customer.primary_contact;
                            self.secondaryContact = response.data.customer.secondary_contact;
                            self.thirdContact = response.data.customer.third_contact;
                            self.locationId = {
                                'id' : response.data.customer.location_id,
                                'name' : response.data.customer.location_name,
                            }
                            self.addressLine1 = response.data.customer.address_line_1;
                            self.addressLine2 = response.data.customer.address_line_2;
                            self.zipCode = response.data.customer.zip_code;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            validateForm: function() {
                var checked = true;
                if (!self.name) {
                    self.nameError = "Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            customerProfileUpdate: function() {
                setTimeout(() => {
                    if (self.checkForm()) {
                        self.buttonNames.saveButton = "Updating ...";
                        self.disableButtons.saveButton = true;
                        var config = {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem("api_token")
                            },
                        };
                        var fields = {
                            id: self.customerLoginId,
                            name: self.name,
                        };
                        HTTP.post("/update-customer-profile", fields, config)
                            .then(function (data) {
                                self.buttonNames.saveButton = "Update";
                                self.disableButtons.saveButton = false;
                                if (data.status == 200) {
                                    self.returnOnListing();
                                    self.showSAlert('Part used successfully', 'success', false);
                                }
                            })
                            .catch(function (error) {
                                self.buttonNames.saveButton = "Update";
                                self.disableButtons.saveButton = false;
                                self.catchHandler(error);
                            })
                    }
                }, 200);
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Customer/CustomerProfile.vue